<span class="mytags" *ngFor="let tag of tags">#{{tag}} </span>